import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PSelectItem } from '../../../../../shared/design-system/atoms/p-select/p-select-item.model';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-bien-agricole-form',
  templateUrl: './bien-agricole-form.component.html',
  styleUrls: ['./bien-agricole-form.component.scss'],
})
export class BienAgricoleFormComponent implements OnChanges {
  @Input() bienAgricole!: Report.Characteristics.BienAgricole | undefined;
  @Input() constructionYear!: number;

  @Output() bienAgricoleChanged =
    new EventEmitter<Report.Characteristics.BienAgricole>();

  @Output() constructionYearChanged = new EventEmitter<number>();

  bienAgricoleForm = new FormGroup({
    propertyType: new FormControl('Bien agricole', { nonNullable: true }),
    constructionYear: new FormControl('', [
      Validators.min(1000),
      Validators.max(9999),
      Validators.pattern(/^\d{4}$/),
    ]),
    landAreaHa: new FormControl(''),
    farmBuildingsAreaM2: new FormControl(''),
    residentialBuildingsAreaM2: new FormControl(''),
    cropType: new FormControl(''),
  });

  hasFarmBuildingsItem!: PSelectItem;
  hasResidentialBuildingItem!: PSelectItem;

  yesNoSelectItems: PSelectItem[] = [
    { value: 'yes', label: 'Oui' },
    { value: 'no', label: 'Non' },
  ];

  bienAgricoleInternal!: Report.Characteristics.BienAgricole;
  constructionYearinternal!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bienAgricole'] && changes['bienAgricole'].currentValue) {
      this.bienAgricoleInternal = changes['bienAgricole'].currentValue;
    }

    if (
      changes['constructionYear'] &&
      changes['constructionYear'].currentValue
    ) {
      this.bienAgricoleForm.controls.constructionYear.setValue(
        this.constructionYear.toString(),
      );
    }

    this.setFormValues();
  }

  onConstructionYearChanged(event: Event) {
    this.constructionYearinternal = parseInt(
      (event.target as HTMLInputElement).value,
    );

    this.constructionYearChanged.emit(this.constructionYearinternal);
  }

  onHasFarmBuildingsSelected({ value }: PSelectItem): void {
    this.bienAgricoleInternal = {
      ...this.bienAgricoleInternal,
      hasFarmBuildings: value === 'yes',
    };

    this.hasFarmBuildingsItem = { value };

    this.bienAgricoleChanged.emit(this.bienAgricoleInternal);
  }

  onHasResidentialBuilding({ value }: PSelectItem): void {
    this.bienAgricoleInternal = {
      ...this.bienAgricoleInternal,
      hasResidentialBuilding: value === 'yes',
    };

    this.hasResidentialBuildingItem = { value };

    this.bienAgricoleChanged.emit(this.bienAgricoleInternal);
  }

  onLandAreaHaChanged(event: Event) {
    this.bienAgricoleInternal = {
      ...this.bienAgricoleInternal,
      landAreaHa: parseFloat((event.target as HTMLInputElement).value),
    };

    this.bienAgricoleChanged.emit(this.bienAgricoleInternal);
  }

  onFarmBuildingsAreaM2Changed(event: Event) {
    this.bienAgricoleInternal = {
      ...this.bienAgricoleInternal,
      farmBuildingsAreaM2: parseInt((event.target as HTMLInputElement).value),
    };

    this.bienAgricoleChanged.emit(this.bienAgricoleInternal);
  }

  onResidentialBuildingsAreaM2Changed(event: Event) {
    this.bienAgricoleInternal = {
      ...this.bienAgricoleInternal,
      residentialBuildingsAreaM2: parseInt(
        (event.target as HTMLInputElement).value,
      ),
    };

    this.bienAgricoleChanged.emit(this.bienAgricoleInternal);
  }

  onCropTypeChanged(event: Event) {
    this.bienAgricoleInternal = {
      ...this.bienAgricoleInternal,
      cropType: (event.target as HTMLInputElement).value,
    };

    this.bienAgricoleChanged.emit(this.bienAgricoleInternal);
  }

  setFormValues(): void {
    this.bienAgricoleForm.controls.constructionYear.setValue(
      this.constructionYearinternal
        ? this.constructionYearinternal.toString()
        : '',
    );

    this.bienAgricoleForm.controls.landAreaHa.setValue(
      this.bienAgricoleInternal?.landAreaHa?.toString() || '',
    );

    this.bienAgricoleForm.controls.farmBuildingsAreaM2.setValue(
      this.bienAgricoleInternal?.farmBuildingsAreaM2?.toString() || '',
    );

    this.bienAgricoleForm.controls.residentialBuildingsAreaM2.setValue(
      this.bienAgricoleInternal?.residentialBuildingsAreaM2?.toString() || '',
    );

    this.bienAgricoleForm.controls.cropType.setValue(
      this.bienAgricoleInternal?.cropType || '',
    );

    if (!this.bienAgricoleInternal.hasFarmBuildings) {
      this.bienAgricoleInternal.hasFarmBuildings = false;
    }

    if (!this.bienAgricoleInternal.hasResidentialBuilding) {
      this.bienAgricoleInternal.hasResidentialBuilding = false;
    }

    this.hasFarmBuildingsItem = this.bienAgricoleInternal?.hasFarmBuildings
      ? this.yesNoSelectItems[0]
      : this.yesNoSelectItems[1];

    this.hasResidentialBuildingItem = this.bienAgricoleInternal
      ?.hasResidentialBuilding
      ? this.yesNoSelectItems[0]
      : this.yesNoSelectItems[1];
  }
}
